import React from 'react'

import { reverse } from 'named-urls'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
} from '@material-ui/core'

import { Edit } from '@material-ui/icons'

import { Skeleton } from '@material-ui/lab'

import { routes } from 'routes'
import { Permitted } from 'components/Permissions'
import DialogTaxType from '../DialogTaxType'
import helpers from 'helpers'
import { LogIconButton } from 'components/Logs'

const TaxTypesTable = ({ data, onEvent = () => {} }) => {
  const fakeData = Array.from(new Array(10))
  const taxTypes = data ? data : fakeData
  const [dialogTaxType, setDialogTaxType] = React.useState(false)
  const [editTaxType, setEditTaxType] = React.useState(null)

  const handleClose = () => {
    setDialogTaxType(false)
    setEditTaxType(null)
  }

  const setTaxType = tax => {
    setEditTaxType(tax)
  }

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="20%">Nome</TableCell>
            <TableCell align="right" width="20%">
              Valor Mínimo Mensal
            </TableCell>
            <TableCell align="right" width="20%">
              Valor Mínimo Diário
            </TableCell>
            <Permitted tag="update_tax_type">
              <TableCell align="right" width="35%"></TableCell>
            </Permitted>
          </TableRow>
        </TableHead>
        <TableBody>
          {taxTypes.map((taxType, index) => {
            if (taxType) {
              return (
                <ItemRow
                  key={index}
                  taxType={taxType}
                  handleOpen={setDialogTaxType}
                  setTaxType={setTaxType}
                />
              )
            }

            return <SkeletonRow key={index} />
          })}
        </TableBody>
      </Table>

      {editTaxType && (
        <DialogTaxType
          open={dialogTaxType}
          handleClose={handleClose}
          taxType={editTaxType}
          onAction={onEvent}
        />
      )}
    </>
  )
}

const ItemRow = ({
  taxType,
  handleOpen = () => {},
  handleChangeStatus,
  setTaxType,
}) => {
  return (
    <TableRow hover key={taxType.id}>
      <TableCell>{taxType.tag}</TableCell>
      <TableCell align="right">
        {helpers.currency(taxType.minimumMonthlyAmount)}
      </TableCell>
      <TableCell align="right">
        {helpers.currency(taxType.minimumDailyAmount)}
      </TableCell>
      <Permitted tag="update_tax_type">
        <TableCell align="right" width="30%">
          <LogIconButton
            to={reverse(routes.settings.taxTypes.logs, {
              taxTypeId: taxType.id,
            })}
          />

          <Permitted tag="update_tax_type">
            <Tooltip title="Editar">
              <IconButton
                aria-label="Editar"
                onClick={() => {
                  setTaxType(taxType)
                  handleOpen(true)
                }}
              >
                <Edit />
              </IconButton>
            </Tooltip>
          </Permitted>
        </TableCell>
      </Permitted>
    </TableRow>
  )
}

const SkeletonRow = () => (
  <TableRow>
    <TableCell>
      <Skeleton variant="rect" width="100%" height={21} />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" height={21} />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width={20} height={21} />
    </TableCell>
  </TableRow>
)

export default TaxTypesTable
